export default __webpack_public_path__ + "static/media/eth.10920c7d.png";